export const headerAndFooterHeight = "15rem";
